var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "wkb-cfde-dataset-run" }, [
    _c("header", { staticClass: "wkb-cfde-dataset-run-head" }, [
      _c("h3", { staticClass: "wkb-cfde-dataset-run-title" }, [
        _vm._v(_vm._s(_vm.runHeadline)),
      ]),
      _vm.startedLabel
        ? _c("span", { staticClass: "wkb-cfde-dataset-run-meta" }, [
            _vm._v(_vm._s(_vm.startedLabel)),
          ])
        : _vm._e(),
    ]),
    _vm.activeSetNodes.length
      ? _c("div", { staticClass: "wkb-cfde-dataset-selected-set" }, [
          _c("div", { staticClass: "wkb-cfde-dataset-selected-set-head" }, [
            _c("strong", [_vm._v("Selected genes used")]),
            _c("span", { staticClass: "wkb-cfde-dataset-run-meta" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.activeSetNodes.length) +
                  " gene" +
                  _vm._s(_vm.activeSetNodes.length === 1 ? "" : "s") +
                  " "
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "wkb-cfde-dataset-chip-list" },
            _vm._l(_vm.activeSetNodes, function (node) {
              return _c(
                "span",
                { key: node.id, staticClass: "wkb-cfde-dataset-chip" },
                [_vm._v(" " + _vm._s(node.label || node.id) + " ")]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm.run.status === "loading"
      ? _c(
          "div",
          {
            staticClass: "wkb-cfde-dataset-loading",
            attrs: { role: "status" },
          },
          [
            _c("span", {
              staticClass: "wkb-cfde-dataset-spinner",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._m(0),
          ]
        )
      : _vm.run.status === "error"
      ? _c(
          "p",
          { staticClass: "wkb-cfde-dataset-error", attrs: { role: "alert" } },
          [
            _vm._v(
              " " +
                _vm._s(_vm.run.error || "CFDE gene-set search failed.") +
                " "
            ),
          ]
        )
      : _vm.run.status === "success" && !_vm.datasets.length
      ? _c("div", { staticClass: "wkb-cfde-dataset-empty" }, [
          _c("h4", [_vm._v("No CFDE gene sets found")]),
          _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.payload.zero_state_reason ||
                    "No CFDE gene sets matched the selected genes."
                ) +
                " "
            ),
          ]),
        ])
      : _vm.run.status === "success" && _vm.datasets.length
      ? _c("div", { staticClass: "wkb-cfde-dataset-results" }, [
          _c("div", { staticClass: "wkb-cfde-dataset-graph-panel" }, [
            _c("div", { staticClass: "wkb-cfde-dataset-graph-head" }, [
              _vm.showRefresh
                ? _c(
                    "button",
                    {
                      staticClass: "wkb-cfde-dataset-refresh-btn",
                      attrs: { type: "button", disabled: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("refresh")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.loading ? "Updating…" : "Update results") +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c("span", { staticClass: "wkb-cfde-dataset-graph-note" }, [
                _vm._v(
                  " Top " +
                    _vm._s(
                      Math.min(
                        _vm.payload.graph_limit || _vm.graphLimit,
                        _vm.datasets.length
                      )
                    ) +
                    " gene sets shown "
                ),
              ]),
              _c("div", { staticClass: "wkb-cfde-dataset-zoom-controls" }, [
                _c(
                  "button",
                  {
                    staticClass: "wkb-cfde-dataset-zoom-btn",
                    attrs: {
                      type: "button",
                      title: "Zoom out",
                      "aria-label": "Zoom out",
                      disabled: _vm.graphZoomLevel <= _vm.graphZoomMin,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.adjustGraphZoom(-_vm.graphZoomStep)
                      },
                    },
                  },
                  [_vm._v(" − ")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.graphZoomLevel,
                      expression: "graphZoomLevel",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "wkb-cfde-dataset-zoom-slider",
                  attrs: {
                    type: "range",
                    min: _vm.graphZoomMin,
                    max: _vm.graphZoomMax,
                    step: _vm.graphZoomStep,
                    "aria-label": "CFDE graph zoom",
                  },
                  domProps: { value: _vm.graphZoomLevel },
                  on: {
                    __r: function ($event) {
                      _vm.graphZoomLevel = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass: "wkb-cfde-dataset-zoom-btn",
                    attrs: {
                      type: "button",
                      title: "Zoom in",
                      "aria-label": "Zoom in",
                      disabled: _vm.graphZoomLevel >= _vm.graphZoomMax,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.adjustGraphZoom(_vm.graphZoomStep)
                      },
                    },
                  },
                  [_vm._v(" + ")]
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "wkb-cfde-dataset-graph-shell" },
              [
                _c("WorkspaceTreeGraphCanvas", {
                  attrs: {
                    "graph-nodes": _vm.graphNodes,
                    "graph-edges": _vm.graphEdges,
                    "contextual-edges": [],
                    "key-node-ids": _vm.activeSetNodeIds,
                    "zoom-level": _vm.graphZoomLevel,
                    "hide-contextual-edges": true,
                    "hide-jumping-edges": true,
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "wkb-cfde-dataset-table-slot" },
            [
              _c("WorkspaceCfdeGeneSetsTable", {
                attrs: {
                  rows: _vm.tableRows,
                  "graph-node-ids": _vm.canvasGraphNodeIds,
                  "graph-busy": _vm.graphBusy,
                },
                on: {
                  "add-gene-set": function ($event) {
                    return _vm.$emit("add-gene-set", $event)
                  },
                  "remove-gene-set": function ($event) {
                    return _vm.$emit("remove-gene-set", $event)
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Finding CFDE gene sets…")]),
      _c("p", [_vm._v("This may take a moment.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }